import { useTranslation } from '@rhino-project/core/i18n';
import { formatNumber } from '@rhino-project/core/i18n/format';
import StarMeter from './StarMeter';

interface RatingScoreProps {
  value: number | null;
  label: string;
  size?: 'sm' | 'lg';
}

// The report's headline grade: a number over a star meter over a short label.
// `lg` is the report-page hero; `sm` is the compact list tile. Purely
// presentational — the caller computes value/label via summarizeReport.
const RatingScore = ({ value, label, size = 'lg' }: RatingScoreProps) => {
  useTranslation();

  const isLg = size === 'lg';
  return (
    <div className="flex flex-col items-center gap-1">
      <span
        className={`font-bold leading-none tabular-nums ${
          isLg ? 'text-3xl' : 'text-xl'
        }`}
      >
        {value == null
          ? '—'
          : formatNumber(value, {
              minimumFractionDigits: 1,
              maximumFractionDigits: 1
            })}
      </span>
      {value != null && (
        <StarMeter
          value={value}
          className={isLg ? undefined : 'text-[0.5rem]'}
        />
      )}
      {label && (
        <span
          className={`uppercase tracking-wide text-muted ${
            isLg ? 'text-xs' : 'text-[0.6rem]'
          }`}
        >
          {label}
        </span>
      )}
    </div>
  );
};

export default RatingScore;
